export enum TitleType {
  search,
  ai, // ask
  learning,
}
